(function () {
'use strict';

const SELECTORS = {
    host: "[data-mb-product-hero] #app-embed",
    language: "custom#language_1",
    product: "custom#nume_produs",
    productData: "[data-mb-product-data]",
    link: "custom#product_link",
};

function getCurrentLanguage() {
    var candidates = [
        document.documentElement.getAttribute('lang'),
        navigator.language,
        navigator.userLanguage
    ];

    for (var i = 0; i < candidates.length; i++) {
        var lang = (candidates[i] || '').toLowerCase();
        if (lang.startsWith('it')) return 'it';
        if (lang.startsWith('ro')) return 'ro';
        if (lang.startsWith('en')) return 'en';
    }

    return 'en'; // fallback
}


function setFieldValue(el, value) {
    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
}

function hideField(el) {
    var wrapper =
        el.closest('[data-field]') ||
        el.closest('.field') ||
        el.closest('div');

    if (wrapper) wrapper.style.display = 'none';
    else el.style.display = 'none';
}


function setLanguageField(root) {
    const languageField = root.getElementById(SELECTORS.language);
    if (!languageField) return;
    setFieldValue(languageField, getCurrentLanguage());
    hideField(languageField);
}

function getProductData() {
    const dataElement = document.querySelector('[data-mb-product-data]');

    if (!dataElement) return null;

    try {
        // .textContent gets the raw string inside the tags
        const rawJson = dataElement.textContent;
        return JSON.parse(rawJson);
    } catch (error) {
        console.error("Bogdan, the JSON is malformed:", error);
        return null;
    }
}


function setProdcutField(root) {

    const linkField = root.getElementById(SELECTORS.link);
    if (!linkField) return;
    setFieldValue(linkField, window.location.href);
    hideField(linkField);
}

function setProdcutName(root) {
    const linkField = root.getElementById(SELECTORS.product);
    if (!linkField) return;

    const productData = getProductData();
    const title = productData?.product?.title

    setFieldValue(linkField, title || document.title);
}

function StyleUI(root) {
    const heading = root.querySelector('h2');
    const header = heading ? heading.closest('section') : null;
    if (header) {
        header.style.margin = '0';
    }

    const submitBtn = root.querySelector('button[type="submit"]')
    if (submitBtn) {
        submitBtn.style.fontSize = '18px'
    }

}

function tryInit() {
    const host = document.querySelector(SELECTORS.host);
    if (!host) return false;
    if (host.closest('offer-request-form')) return true;
    const root = host.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('form')) return false;

    setLanguageField(root);
    setProdcutField(root);
    setProdcutName(root);
    StyleUI(root);

    return true;
}

function waitUntilReady(maxWaitMs) {
    const start = Date.now();
    const interval = setInterval(() => {
        // Check the deadline before initialization, so an exception cannot bypass it.
        if (Date.now() - start >= maxWaitMs) {
            clearInterval(interval);
            return;
        }
        try {
            if (tryInit()) clearInterval(interval);
        } catch (error) {
            clearInterval(interval);
            console.error('Could not initialize the product Shopify form:', error);
        }
    }, 200);
}

waitUntilReady(5000);
})();

// Offer UI bridge. All field lookups stay inside this instance's app block,
// including the open shadow roots created by Shopify Forms.
if (!customElements.get('offer-request-form')) {
  customElements.define('offer-request-form', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      clearTimeout(this.readyTimer);
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.form = this.querySelector('[data-offer-form]');
      this.container = this.querySelector('[data-offer-shopify-form]');
      if (!this.form || !this.container) return;

      this.fields = Object.fromEntries(
        [...this.form.querySelectorAll('[data-offer-field]')].map(field => [field.dataset.offerField, field])
      );
      this.button = this.form.querySelector('[type="submit"]');
      this.status = this.querySelector('[data-offer-status]');
      this.success = this.querySelector('[data-offer-success]');
      this.setAttribute('data-enhanced', '');
      this.container.setAttribute('aria-hidden', 'true');
      this.container.inert = true;
      this.form.hidden = !this.success.hidden;

      this.form.addEventListener('input', () => this.syncFields(), { signal });
      this.form.addEventListener('change', () => this.syncFields(), { signal });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.form.reportValidity()) this.submitToShopify();
      }, { signal });

      // Shadow roots may attach after the app block has entered the document.
      // Keep trying until mounted; disconnecting the section cancels this timer.
      const initialize = () => {
        if (signal.aborted || !this.success.hidden) return;
        const target = this.getTarget();
        if (target) {
          this.syncConstraints(target);
          this.syncFields(target);
        } else {
          this.readyTimer = setTimeout(initialize, 200);
        }
      };
      initialize();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      clearTimeout(this.readyTimer);
    }

    getRoots() {
      const roots = [this.container];
      for (let index = 0; index < roots.length; index++) {
        for (const element of roots[index].querySelectorAll('*')) {
          if (element.shadowRoot) roots.push(element.shadowRoot);
        }
      }
      return roots;
    }

    getTarget() {
      for (const root of this.getRoots()) {
        const fields = {
          name: root.querySelector('[id="first_name"]'),
          email: root.querySelector('[id="email"]'),
          company: root.querySelector('[id="custom#companie"]'),
          phone: root.querySelector('[id="phone_number"]'),
          product: root.querySelector('[id="custom#nume_produs"]'),
          link: root.querySelector('[id="custom#product_link"]'),
          language: root.querySelector('[id="custom#language_1"]'),
          message: root.querySelector('textarea[name="custom#message"]')
        };
        if (Object.values(fields).some(field => !field)) continue;
        const form = fields.email.closest('form');
        const scope = form || fields.email.closest('[role="form"]') || root;
        const button = scope.querySelector('button[type="submit"]');
        if (button) return { root, fields, form, button };
      }
      return null;
    }

    syncConstraints(target) {
      for (const [key, field] of Object.entries(this.fields)) {
        const official = target.fields[key];
        field.required = official.required;
        for (const attribute of ['maxlength', 'minlength', 'pattern']) {
          if (official.hasAttribute(attribute)) {
            field.setAttribute(attribute, official.getAttribute(attribute));
          } else {
            field.removeAttribute(attribute);
          }
        }
      }
    }

    getPayload() {
      const payload = Object.fromEntries(
        Object.entries(this.fields).map(([key, field]) => [key, field.value.trim()])
      );
      const language = (this.dataset.language || document.documentElement.lang || 'en').toLowerCase();
      payload.language = ['it', 'ro', 'en'].find(code => language.startsWith(code)) || 'en';
      payload.link = window.location.href;
      return payload;
    }

    syncFields(target = this.getTarget(), payload = this.getPayload(), force = false) {
      if (!target || (this.isSubmitting && !force)) return;
      for (const [key, field] of Object.entries(target.fields)) {
        if (field.value === payload[key]) continue;
        // Use the native setter so React-controlled app inputs update as well.
        const prototype = field.tagName === 'TEXTAREA'
          ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
        const setter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
        if (setter) setter.call(field, payload[key]);
        else field.value = payload[key];
        field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
        field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      }
    }

    setStatus(message) {
      this.status.textContent = message;
      this.status.hidden = !message;
    }

    async waitForTarget(signal) {
      for (let attempt = 0; attempt < 100; attempt++) {
        signal.throwIfAborted();
        const target = this.getTarget();
        if (target) return target;
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      throw new Error(this.dataset.unavailableMessage);
    }

    async waitForResponse(signal) {
      for (let attempt = 0; attempt < 300; attempt++) {
        signal.throwIfAborted();
        // Re-discover roots: Shopify can replace its form or shadow host.
        for (const root of this.getRoots()) {
          const errors = [...root.querySelectorAll('[role="alert"], [aria-invalid="true"]')];
          const error = errors.find(element => !element.hidden &&
            (element.textContent.trim() || element.validationMessage));
          if (error) throw new Error(error.validationMessage || error.textContent.trim());
        }
        const roots = this.getRoots();
        if (!roots.some(root => root.querySelector('[id="email"]'))) {
          const response = roots.flatMap(root => [...root.querySelectorAll('h1, h2, h3, p, [role="status"]')])
            .filter(element => !element.hidden && !element.closest('[hidden]'))
            .map(element => element.textContent.trim()).filter(Boolean).join(' ');
          if (response) return response;
        }
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      throw new Error(this.dataset.unconfirmedMessage);
    }

    async submitToShopify() {
      if (this.isSubmitting) return;
      const { signal } = this.abortController;
      const payload = this.getPayload();
      this.isSubmitting = true;
      this.button.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.setStatus(this.dataset.loadingMessage);

      try {
        let target = await this.waitForTarget(signal);
        this.syncConstraints(target);
        if (!this.form.reportValidity()) {
          this.setStatus('');
          return;
        }
        this.syncFields(target, payload, true);
        // Let the app process its controlled-input updates before clicking.
        await new Promise(resolve => setTimeout(resolve, 0));
        signal.throwIfAborted();
        target = this.getTarget();
        if (!target) throw new Error(this.dataset.unavailableMessage);

        const invalidEntry = Object.entries(target.fields).find(([, field]) => !field.checkValidity());
        if (invalidEntry) {
          const [key, official] = invalidEntry;
          this.fields[key]?.focus();
          const label = this.fields[key]?.labels?.[0]?.textContent.trim();
          throw new Error([label, official.validationMessage].filter(Boolean).join(': ') || this.dataset.invalidMessage);
        }
        if (target.form && !target.form.checkValidity()) throw new Error(this.dataset.invalidMessage);
        if (target.button.disabled) throw new Error(this.dataset.unavailableMessage);
        target.button.click();
        const response = await this.waitForResponse(signal);
        this.querySelector('[data-offer-response]').textContent = response;
        this.form.hidden = true;
        this.success.hidden = false;
        this.success.focus();
        this.setStatus('');
      } catch (error) {
        if (!signal.aborted) this.setStatus(error.message);
      } finally {
        this.isSubmitting = false;
        this.button.disabled = false;
        this.form.setAttribute('aria-busy', 'false');
      }
    }
  });
}
